import Axios, { type AxiosInstance, type CancelTokenSource } from 'axios'
import dayjs from 'dayjs'
import type { PiralPlugin } from 'piral-core'
import qs from 'qs'
import { dayjsToApiString } from '../../dayjs/dayjs.util'
import oidc from '../user/oidcClient'
export interface FetchApi {
  axiosInstance(): AxiosInstance
  createCancelTokenSource(): CancelTokenSource
}

export function createWrwksFetchApi(): PiralPlugin<FetchApi> {
  const instance = Axios.create({
    baseURL: '/',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  instance.interceptors.request.use(
    async (request) => {
      const token = await oidc.token()
      if (token) {
        request.headers.Authorization = `Bearer ${token}`
      }

      if (request.params) {
        Object.keys(request.params).forEach((key) => {
          if (request.params[key] instanceof dayjs) {
            request.params[key] = dayjsToApiString(request.params[key] as dayjs.Dayjs)
          }
        })
        request.paramsSerializer = {
          serialize: (params) => qs.stringify(params, { arrayFormat: 'repeat', encode: true }),
          indexes: null
        }
      }

      return request
    },
    (error) => Promise.reject(error)
  )

  return () => ({
    axiosInstance: () => instance,
    createCancelTokenSource: () => Axios.CancelToken.source()
  })
}
